export class callOutState {
  constructor(callOutInfoJson) {
    this.callId = callOutInfoJson.CallId;
    this.callOutId = callOutInfoJson.CallOutId;
    this.calloutMaxTime = callOutInfoJson.CalloutMaxTime;
    this.camId = callOutInfoJson.CamId;
    this.phoneNumber = callOutInfoJson.PhoneNumber;
    this.currentState= callOutInfoJson.currentState;
    this.action = callOutInfoJson.action;
  }
}
